import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-report\"><defs><style type=\"text/css\"></style></defs><path d=\"M569.469659 61.78636c-15.547699 0-28.152751 12.605052-28.15275 28.152751v359.704225c0 15.547699 12.605052 28.152751 28.15275 28.152751h359.717536c15.547699 0 28.152751-12.605052 28.152751-28.152751 0-213.868143-174.002144-387.856976-387.870287-387.856976z m28.152751 359.704225V119.274449c160.408018 13.554194 288.676276 141.808117 302.23047 302.216136h-302.23047z\" fill=\"#3E3A39\" p-id=\"2498\" /><path d=\"M804.122674 561.443422c0 188.272034-153.163006 341.44835-341.435039 341.44835S121.238261 749.714432 121.238261 561.443422s153.17734-341.435039 341.44835-341.435039h28.152751v-56.305502H462.686611c-219.325452 0-397.753852 178.429424-397.753851 397.740541 0 219.325452 178.429424 397.753852 397.753851 397.753852 219.311117 0 397.740541-178.429424 397.740541-397.753852v-28.152751H804.12165v28.152751z\" fill=\"#3E3A39\" p-id=\"2499\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/report.svg
// module id = 2nwU
// module chunks = 60